import { FC } from "react";
import { toAbsoluteUrl } from "../../../_theme/helpers";

export type InfrastructureSectionProps = {
    id: string;
    tag: string;
    title: string;
    description?: React.ReactNode;
    content: React.ReactNode;
    variant?: "white" | "gray";
    sideImage?: string;
};

const InfrastructureSection: FC<InfrastructureSectionProps> = ({
    id,
    tag,
    title,
    content,
    variant = "white",
    description,
    sideImage,
}) => {
    return (
        <div
            id={id}
            className={`moip-section section-padding ${variant === "gray" ? "ct-grag-bg" : "bg-white"
                }`}
        >
            <div className="row d-flex flex-column-reverse flex-lg-row g-10 align-items-center m-0">

                <div className={`${sideImage ? "col-md-8" : "col-md-12"} px-10 px-sm-15 px-xs-10 px-md-10 px-lg-20 px-xl-20  pe-lg-5 pe-xl-5`}>
                    <div className="details">
                        <h5 className="box-tag">{tag}</h5>
                        <h3 className={`${description ? "mb-0" : "mb-3"} box-title`}>{title}</h3>
                        {description && <div className="box-description mb-3">{description}</div>}
                        {content}
                    </div>
                </div>

                {sideImage && (
                    <div className="col-md-4 d-flex align-items-center justify-content-center text-end px-10 px-sm-15 px-xs-10 px-md-10 px-lg-10 px-xl-20  ps-lg-5 ps-xl-5">
                        <img
                            src={toAbsoluteUrl(sideImage)}
                            alt={title}
                            loading="lazy"
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default InfrastructureSection;